import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCcunL8FiyoZGLX3kZFEzXt6VZgfb8Z920",
  authDomain: "asda-340c4.firebaseapp.com",
  projectId: "asda-340c4",
  storageBucket: "asda-340c4.appspot.com",
  messagingSenderId: "271914635789",
  appId: "1:271914635789:web:337aed1a38beb8d337bb44",
  measurementId: "G-HNNGKV5YXJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth with improved error handling
const auth = getAuth(app);
auth.useDeviceLanguage(); // Set language to user's device language

// Initialize Firestore with persistence
const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

// Initialize Storage
const storage = getStorage(app);

// Remove Supabase environment variables since we're using Firebase
if (import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.VITE_SUPABASE_URL) {
  console.warn('Supabase environment variables detected but not used. This project uses Firebase for authentication.');
}

export { app, auth, db, storage };